"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var ContentLine_1 = require("../contentLine/ContentLine");
var preferredConsultantStyles_1 = require("./preferredConsultantStyles");
var PreferredConsultant = function (_a) {
    var name = _a.name;
    var style = preferredConsultantStyles_1.default();
    return (<core_1.Box data-test="summary:container:preferred_consultant" className={style.wrapper}>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" className={style.title}>
            <react_intl_1.FormattedMessage id="myPreferredConsultant.header"/>
          </core_1.Typography>} dataTest="summary:preferred_consultant:title"/>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">{name}</core_1.Typography>} dataTest="summary:preferred_consultant:name" className={style.element}/>
    </core_1.Box>);
};
exports.default = PreferredConsultant;
